import {
  AREAOFFICERS_REQUEST,
  AREAOFFICERS_FAILURE,
  FETCH_AREAOFFICERS_SUCCESS,
  CREATE_AREAOFFICERS_SUCCESS,
  DELETE_AREAOFFICERS_SUCCESS,
  UPDATE_AREAOFFICERS_SUCCESS,
  GET_AREAOFFICERS_SUCCESS,
} from "../action/types";

const initialState = {
  areaOfficers: [],
  total: 0,
  currentAreaOfficer: null,
  loading: false,
  error: null,
};

const areaOfficersReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AREAOFFICERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_AREAOFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        areaOfficers: payload?.data ?? (Array.isArray(payload) ? payload : []),
        total: payload?.total ?? (Array.isArray(payload) ? payload.length : 0),
      };

    case GET_AREAOFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentAreaOfficer: payload,
        areaOfficers: state.areaOfficers.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case CREATE_AREAOFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        areaOfficers: [payload, ...state.areaOfficers],
        total: state.total + 1,
      };

    case UPDATE_AREAOFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        areaOfficers: state.areaOfficers.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_AREAOFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        areaOfficers: state.areaOfficers.filter((item) => item.id !== payload),
        total: state.total - 1,
      };

    case AREAOFFICERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default areaOfficersReducer;
